import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import KineticMarquee from "@/components/KineticMarquee";
import About from "@/components/About";
import Approach from "@/components/Approach";
import BrutalDesign from "@/components/BrutalDesign";
import Monologue from "@/components/Monologue";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import SEOHead from "@/components/SEOHead";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#050505] text-[#f5f5f5]">
      <SEOHead route="home" />
      <Header />
      <Hero />
      <KineticMarquee />
      <About />
      <Approach />
      <BrutalDesign />
      <Monologue />
      <Gallery />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
